import { em } from 'polished'
import styled, { css } from 'styled-components'

import DynamicImage from 'components/DynamicImage'

export const Wrapper = styled.div`
  position: relative;
  width: ${em(420)};
  max-width: 120%;
  left: -10%;
  margin: 0 auto;
  padding-top: ${em(40)};

  ${p => p.theme.mq.upThreshold(390)} {
    left: -${em(15)};
  }

  ${p => p.theme.mq.upThreshold(420)} {
    left: initial;
  }

  ${p => p.theme.mq.upMd} {
    position: absolute;
    width: ${em(750)};
    max-width: none;
    background-position: 0 0;
    height: ${em(280)};
    right: -19%;
    padding-top: ${em(50)};
  }

  ${p => p.theme.mq.upLg} {
    position: relative;
    right: auto;
    max-width: 115%;
    width: ${em(868)};
  }
`

export const DynamicImageStyled = styled(DynamicImage)`
  ${p => p.theme.mq.upMd} {
    height: inherit;
    object-position: left top;
  }
`

export const DiscountLabel = styled.div`
  position: absolute;
  top: 10%;
  right: 13%;
  width: ${em(60)};
  height: ${em(60)};
  border-radius: 50%;
  background: ${p => p.theme.colors[p.bg || 'yellow']};
  color: ${p => p.theme.colors[p.textColor || 'black']};
  display: flex;
  align-items: center;
  justify-content: center;
  transform-origin: center;
  transform: rotateZ(15deg);

  ${p => p.theme.mq.upMd} {
    top: 12%;
    right: 15%;
  }

  ${p => p.theme.mq.upLg} {
    width: ${em(104)};
    height: ${em(104)};
    right: initial;
    left: 5%;
    top: -3%;
  }
`

export const LabelValue = styled.span`
  font-size: ${em(16)};
  line-height: ${em(21, 16)};
  text-align: center;

  ${p => p.theme.mq.upLg} {
    font-size: ${em(27)};
    line-height: ${em(35, 27)};
  }

  ${({ isPrefix }) =>
    isPrefix &&
    css`
      margin-top: -${em(5, 16)};

      ${p => p.theme.mq.upMd} {
        margin-top: -${em(10, 27)};
      }
    `}
`
